export const baseURL = "https://tnp-vault.vercel.app";
// export const baseURL = "http://localhost:8000";



